import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import IconsSend from '@mui/icons-material/Send';
import React from 'react';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import ButtonSubmit from '../_button/ButtonSubmit';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'sticky',
    bottom: 0,
    backgroundColor: theme.palette.mode === 'light' ? 'white' : 'black',
    zIndex: 1,
    padding: theme.spacing(2),
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
}));

interface IProps {
  onCancel?: () => void;
  onSubmit: () => void;
  isSubmitting: boolean;
  cancelText?: string;
  submitText?: string;
  disabled?: boolean;
}

export default function StickyFormFooter(props: IProps) {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    onCancel,
    onSubmit,
    isSubmitting,
    cancelText,
    submitText,
    disabled,
  } = props;

  return (
    <Grid item xs={12} className={classes.root}>
      <Grid container spacing={2} justifyContent="flex-end">
        {onCancel && (
          <Grid item>
            <Button variant="text" onClick={onCancel}>
              {cancelText || t('cancel')}
            </Button>
          </Grid>
        )}
        <Grid item>
          <ButtonSubmit
            variant="contained"
            color="primary"
            disabled={disabled}
            onClick={onSubmit}
            isSubmitting={isSubmitting}
            label={submitText || t('submit')}
            icon={<IconsSend />}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
